import React, { useEffect, useState } from "react";
import styles from "./InstagramPopup.module.css";

import instaDownload from "../../assests/instaDownload.svg";
import PopupWrapper from "../../Layout/PopupWrapper";
import copyLinkImage from "../../assests/share/copyLink.svg";
import copySuccess from "../../assests/share/copySuccess.svg";
const InstagramPopup = ({ setPopup, backgroundColor, message }) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  function copyLink() {
    setCopied(true);
    setTimeout(() => {
      setPopup(false);
    }, [1000]);
    navigator.clipboard.writeText(window.location.href);
    window.document.execCommand("copy");
    // alert(copyText + "\n copied to clipboard")
  }
  return (
    <PopupWrapper>
      <div className={styles.mainDiv}>
        <div className={styles.container}>
          <img
            src={instaDownload}
            alt=""
            className="w-[56px] h-[56px] mb-[16px]  "
          />
          {/* <p className="text-regular-medium px-[20px] mb-[16px]">
          Option to dislike is disabled
        </p> */}
          <pre className="text-small text-[#CDCDCD] ">{message}</pre>
          <div className="seperator my-[20px]" />
          <div className="  w-[100%] cursor-pointer">
            <div
              className="flex flex-row items-center justify-between w-[100%] text-left "
              onClick={copyLink}
              tooltip="Copy to clipboard"
            >
              <div className="w-[calc(100%-50px)]">
                <p className="text-regular-medium">Copy the link </p>
                <p className="text-small break-words text_1Line text-[#CDCDCD]">
                  {window.location.href}
                </p>
              </div>
              <div className="w-[24px] h-[24px]">
                {copied ? (
                  <img src={copySuccess} className="" />
                ) : (
                  <img src={copyLinkImage} className="" />
                )}
              </div>
            </div>
            <div className="seperator my-[20px]" />

            <button
              className={`text-regular-medium ${styles.button}`}
              onClick={() => setPopup(false)}
              style={{
                backgroundColor: "none",
                border: `1px solid ${backgroundColor}`,
                color: "#fff",
              }}
            >
              Ok
            </button>
          </div>
        </div>
      </div>
    </PopupWrapper>
  );
};

export default InstagramPopup;
